// @avantia common-code
// generated from 'generate-question-id-constants-functions.ts' at 2026-08-24T09:08:42.066Z
// questionSetId: 3c799ab6-201e-4c6c-8749-39d06a832ec4

const questionIdMap: HpQuestionIds = {
  accidentalDamageLevelBuildings: '9a6f90d4-c204-4b81-a048-c245993b0408',
  accidentalDamageLevelContents: 'ee19e6d9-a04f-4940-b63b-d062baddc6ff',
  accountHolderName: '8e1395ae-904c-4e19-8d13-2e1050f89d3b',
  accountHolderNameSomeoneElse: '66f9c46d-68d0-41cc-add3-99bf23f9cd98',
  accountNumber: 'a45aff48-1b1a-40f5-8292-abad6dde5271',
  actionTaken: 'b8dc157d-c48b-49cf-8f2e-18d3ba234a3b',
  activeSectionId: 'activeSectionId',
  adAddAnotherItemButton: '8e9f0a1b-2c3d-44e5-f6a7-b8c9d0e1f2a3',
  adBoundaryAreaAffected: 'b9873dd3-29ea-433f-b024-45a563a83465',
  adBoundaryDamageExtent: '50b95a45-07fc-4a29-9213-15a0b6ce2da0',
  adBoundaryExtentBack: '3e80a6ed-384e-4fe3-99fa-75b603076ddf',
  adBoundaryExtentContinue: 'eb967982-4a06-44fa-9bcb-eb69901ed11e',
  adBoundaryIsBespoke: '3a561cee-a478-4561-8e6f-5dc438f6f4a2',
  adBoundaryIsRetainingWall: '7f2c1d4a-3b58-4e90-a6c7-1d82f5b39e04',
  adBoundaryItemsDamaged: '9b401272-8154-4220-be2d-3b406e04940d',
  adBoundarySpecialistRequired: '58d6295b-8981-4ead-a2d1-b3a698ff7117',
  adBuildingsAreaDamaged: '03de0e89-cac9-4d25-b20a-05238fc2eccf',
  adBuildingsExtentBack: 'b4c5d6e7-f809-4102-1324-a5b6c7d8e9f0',
  adBuildingsExtentContinue: 'a3b4c5d6-e7f8-4091-0213-24a5b6c7d8e9',
  adBuildingsIncidentBack: '023156dc-3775-444e-84c2-49c73dbdb1e1',
  adBuildingsIncidentContinue: 'aba1a0d2-d8c1-4d77-9695-48e8bdc3394a',
  adBuildingSubmitClaim: '1f4a7c62-8b90-4d35-9e21-3c5a6d80b7f4',
  adBuildingsWhatCaused: '33833398-eeba-4f56-b11f-8662b17e3482',
  adBuildingsWhoCaused: 'bd0f6e18-b989-400f-a149-7b269da33acd',
  adConservatoryAreaAffected: '5f917da8-8e64-4c92-d415-a02936bec7d8',
  adConservatoryDamageExtent: '4e806c97-7d53-4b81-c304-9f1825adb6c7',
  adConservatoryExtentBack: '7b139fca-a086-4eb4-f637-c24b58d0e9fa',
  adConservatoryExtentContinue: '6a028eb9-9f75-4da3-e526-b13a47cfd8e9',
  adConservatoryIsBespoke: '2c8e4a75-5b31-4f69-a1e2-7d96038bf4a5',
  adConservatoryItemsDamaged: '1b9d3f6c-4a27-4e58-b0d1-6c85f2a7e394',
  adConservatorySpecialistRequired: '3d7f5b86-6c42-4a70-b2f3-8e07149ca5b6',
  adContentsIncidentBack: '10213244-5b6c-4d8e-9f0a-1b2c3d4e5f6a',
  adContentsIncidentContinue: '09102132-4a5b-4c7d-8e9f-0a1b2c3d4e5f',
  adContentsSubmitClaim: '9f0a1b2c-3d4e-45f6-a7b8-c9d0e1f2a3b4',
  adContentsSubmitClaimBack: '0a1b2c3d-4e5f-46a7-b8c9-d0e1f2a3b4c5',
  adContentsWhatHappened: 'd6e7f809-1021-4324-a5b6-c7d8e9f0a1b2',
  adContentsWhereHappened: 'c5d6e7f8-0910-4213-24a5-b6c7d8e9f0a1',
  adContentsWhoCaused: 'e7f80910-2132-4a5b-6c7d-8e9f0a1b2c3d',
  adCoverLevel: '27c87427-1c88-4b18-8c87-e696c2beaf13',
  addAnotherRoomButton: '140ddcfa-fd33-4f81-a1ee-3a183e24de8e',
  addonCode: '04dc90a3-ef78-4980-a030-6d53f95212af',
  addonDescription: '7cd6ecd6-a2f2-448a-82d7-befdc0e6bd17',
  addonDetails: 'b2d00bba-0990-4aed-9047-78ff9fbddcdd',
  addonWarning: '5dce8d4c-8f35-4ef9-8d6c-749b1744c4eb',
  addressCancelEdit: '0bf2ac77-9381-4f90-9495-f508c1ebca71',
  addressDataBeforeEdit: '3f5d6554-0792-4f10-8283-ca53044a6704',
  addressDetails: 'address-details',
  addressEdit: '4cc8bdd4-a6c1-446d-935f-4f30c6808be0',
  addressEnterManuallyButton: '5bbc0978-c0cd-4110-8ad9-bccdeedd6955',
  addressId: '86676452-9631-4ca5-a93d-e0217990a253',
  addressLine1: '93680d0a-8dcb-40fd-a874-85a31a1b7c7b',
  addressLine2: '1e9d0d76-7227-4fc6-83c5-bd8d280f2755',
  addressLookupButton: '41569e85-b7d3-41ae-8ab7-20f878933158',
  addressLookupJson: '4a96bc2b-002a-4376-a27e-76302eaf6347',
  addressLookupResults: '225c6c3d-df13-411e-ad19-5fddaf372aac',
  addressPolicyholderName: 'a1c2ea1d-f0de-476f-bdd9-d4d9d3372f36',
  adDrivewayAreaAffected: '1be317e3-840f-4e40-9f54-c780e6c5cc95',
  adDrivewayDamageExtent: '518be997-a3d5-403d-868f-12d973b5c857',
  adDrivewayExtentBack: '95597944-3368-41fa-bbfe-5eb18c2f78b7',
  adDrivewayExtentContinue: 'a30f6543-749c-47da-a8b2-1484112b7792',
  adDrivewayIsBespoke: '1e568103-6577-4ce4-b517-6c6afb1fc9b0',
  adDrivewayItemsDamaged: '5710a3a5-4a45-49fa-921a-95b44387a39c',
  adDrivewaySpecialistRequired: '79705530-ef91-4211-b496-44d78caf1bda',
  adEssentialFacilitiesLost: 'f2a3b4c5-d6e7-4f80-9102-1324a5b6c7d8',
  adExternalWallAreaAffected: 'c9d0e1f2-a3b4-4c5d-6e7f-8091021324a5',
  adExternalWallDamageExtent: 'b8c9d0e1-f2a3-4b4c-5d6e-7f8091021324',
  adExternalWallExtentBack: '97610ffb-2c94-4f6e-8b43-9a80a6ebb74b',
  adExternalWallExtentContinue: '6645b85e-c1b6-4d37-ba1c-3f4b242b4b97',
  adExternalWallIsBespoke: 'f6a7b8c9-d0e1-4f2a-3b4c-5d6e7f809102',
  adExternalWallItemsDamaged: 'e5f6a7b8-c9d0-4e1f-2a3b-4c5d6e7f8091',
  adExternalWallSpecialistRequired: 'a7b8c9d0-e1f2-4a3b-4c5d-6e7f80910213',
  adIntroBack: '8076dab9-57a3-4938-abda-dc05aa31d4f2',
  adIntroContinue: '5b5fa037-0afd-4e5b-9e68-d34e94f77f77',
  adItemDamageExtent: '5b6c7d8e-9f0a-41b2-c3d4-e5f6a7b8c9d0',
  adjustmentNeeded: '90927b55-f331-4296-a508-ba6a2b54a219',
  adOutbuildingAreaAffected: 'beeff57d-2331-4335-bd4d-9bd8580e547e',
  adOutbuildingCeilingFinish: '7107b2e8-8a5e-4be3-bb35-3db2953df4f1',
  adOutbuildingDamageExtent: '16d37495-2571-438d-a4a3-d2370995f483',
  adOutbuildingExtentBack: 'd692e998-811e-4879-b24a-54c6beacb7b4',
  adOutbuildingExtentContinue: 'eae947f3-611d-4938-9743-68f899e6ea19',
  adOutbuildingIsBespoke: '1c66a0e4-aa2d-4526-af98-a2b626cffb2f',
  adOutbuildingItemsDamaged: 'ec1e7e23-4215-4cf4-b850-413e81881e27',
  adOutbuildingSpecialistRequired: '68af3810-ddf8-40b1-a268-426166b3d328',
  adOutbuildingSubFloorMaterial: '6f6d2198-957a-4fff-92e6-ec72d60b4ed6',
  adRemoveItemButton: '7d8e9f0a-1b2c-43d4-e5f6-a7b8c9d0e1f2',
  adRoofAreaAffected: 'd4e5f6a7-b8c9-4d0e-1f2a-3b4c5d6e7f80',
  adRoofDamageExtent: 'c3d4e5f6-a7b8-4c9d-0e1f-2a3b4c5d6e7f',
  adRoofExtentBack: '7347e47a-8e18-4361-91d6-df4fa6d09072',
  adRoofExtentContinue: 'da09559b-96ec-4b5f-a641-caec652c7b4f',
  adRoofIsBespoke: 'a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5d',
  adRoofItemsDamaged: '67c5c3c3-2d52-461c-87d8-03e4edc15f96',
  adRoofSpecialistRequired: 'b2c3d4e5-f6a7-4b8c-9d0e-1f2a3b4c5d6e',
  adUgsAreaAffected: '5c3a64a2-5775-41a9-a7cb-be1d47031d51',
  adUgsExtentBack: '186dd869-685a-4a94-907f-8a39857b1744',
  adUgsExtentContinue: '5297af08-02a9-4b96-9edc-a858e2f34151',
  adUgsItemsDamaged: 'e2fc392d-cd10-4468-beaf-1e25ddd41378',
  adWindowsAreaAffected: '94e385bf-23ac-4507-9f40-fc3c48de49c8',
  adWindowsDamageExtent: 'd1bd1fa4-38fd-46c1-8735-2ed237b88c23',
  adWindowsExtentBack: '912580d4-1a7f-47ad-884a-0bc12e8c0f9f',
  adWindowsExtentContinue: 'c9d0a193-26b4-4d17-8774-c2508942ac05',
  adWindowsIsBespoke: 'd1fa4dc1-3ecf-4f0e-983f-9d601f5a88da',
  adWindowsItemsDamaged: '761a7648-6b83-44ca-9381-c7fc731fe0ff',
  adWindowsSpecialistRequired: 'cc08fe8f-debc-484c-accc-49619af6e340',
  affectedSpecifiedItems: '2a958254-308a-4ed0-9e74-b863ee433fed',
  altPhoneNumber: 'f6500f42-2ce4-4710-a1bd-32ad5bcf0d49',
  areSpecifiedItemsAffected: 'ddb4fa34-3cb3-47cf-933d-cfcfafb1a251',
  areSpecifiedItemsAffectedValue: 'b0d713ea-5eac-49fc-a2b8-b40112caba8e',
  backToEnquiryDetails: 'a4e771e5-5a2f-4008-9146-f3d717e37d28',
  buildingsSumInsured: '9243cef5-7102-4c79-9e47-53033b727467',
  ceilingFinish: 'd0e1f2a3-b4c5-4d6e-7f80-91021324a5b6',
  checkYourCover: 'f4c9c0a8-3d42-4598-b1a8-c399aada6776',
  claimEnquiryReference: '4ed8c761-b8e2-4e89-adc5-7e3ed576b1dd',
  claimReference: 'e2c9e07e-c9b2-4548-bfc1-01b30642dc8c',
  claimStartedDate: 'eb0d47db-168d-47bc-bf28-f638ae6ba453',
  claimSubmittedDate: '60c71bdb-3404-4192-acbb-ccdf9592f107',
  compulsoryExcessBuildings: 'd3587fa8-c6aa-49e6-b9ca-ad4822d46fa2',
  compulsoryExcessContents: '958ecd35-d916-4ae7-a5d6-86e04d94bf21',
  contentsSumInsured: '02a87dbd-e6c8-484e-a0eb-8a43b0e26755',
  correspondenceAddress: '6a28b056-07b5-48c2-a649-7267acfdcaf4',
  country: '94e1298c-f5df-46b5-813c-4b75759b6b61',
  county: '6e5b62a7-f89a-48d3-b758-46b099d35eb6',
  coverName: '5fce5350-47f1-414c-9fe6-f3532802d80b',
  coverSummaryAlert: '27023ab7-e7dd-4365-8ab6-1bcd09f7fc9f',
  coverType: '86ea56bb-25da-4e96-824b-33dbfd13e6b2',
  crimeReferenceNumber: '9e52d8c3-16f7-4b40-a029-4c7db8e32f61',
  customData: 'customData',
  customerDetails: 'b6b8d2a2-3884-4d00-a3a0-2b01a66e6417',
  damagedContentsItems: '9c5b5271-627c-4ff9-beed-1b5a3560c62f',
  damagedContentsItemsOther: '360144d7-8c4e-419d-8dd2-adc45994f141',
  damagedElementAreaAffected: 'fd6c2e42-44ef-4593-b951-1d1ade9e4159',
  damagedElementIsBespoke: '34ee95dd-eeba-493d-8518-6a879f6da46a',
  damagedElementSpecialistRequired: '9d2661f8-610a-4e73-a19b-c57f7e85218d',
  damagedItemDescription: '68af6fab-8e14-425a-9398-981dafd10870',
  damagedItemMakeModel: '169964c4-6010-4efd-97dc-94a6096638a7',
  damagedItemOther: '6bd8a7bb-fa49-456d-9120-41be6e7a5ce4',
  damageExtent: 'ecb80552-904a-4477-b554-c30c92f2356f',
  damageType: '244980cc-c624-4283-9cc7-299befc548f2',
  dateOfBirth: '480029b3-4168-42e7-8f14-81530d737832',
  declaration: '8d8a69ed-94d6-46d0-b4a3-35d432db012c',
  emailAddress: '9d7121de-968a-44b7-9ee2-e026309a4189',
  endDate: 'afde8795-13ef-4997-a04c-d052ee87b032',
  endorsementCode: 'cf58ff93-76e7-4296-af49-b7cd4d40a466',
  endorsementDescription: '47106b39-de7b-4579-9921-808b21f86e58',
  endorsementDetails: '63030dc9-7e70-46be-b06d-127619713d9e',
  endorsementHeader: '39ceace5-3e08-4b06-93c8-cc4c85ed3fac',
  eowExcessBuildings: '96681e40-4c5b-4d67-a5f9-fcccbab4aa52',
  eowExcessContents: '76a92e92-72b2-48ed-b5bb-e785ce3b808f',
  essentialFacilitiesLost: '7a4f19c1-8599-4e91-8e86-fec3df590312',
  excesses: '33084b7e-cb0d-4f0e-a079-26a088ba0fea',
  extentOfDamageBack: '5d2de927-9679-42f8-8b4b-f889370d63cf',
  extentOfDamageContinue: 'b3f2a1c4-d5e6-4f78-9012-3456789abcde',
  extentOfDamageSubmitClaim: '398ef782-44b5-427f-a222-e410ca47de39',
  floodAreaDamaged: '3c0833ec-341a-4400-a3b4-941f75d4543b',
  floodElectricsAffected: '1556c60b-9ecf-4e15-8f5b-f624c552d2a2',
  floodStandingWaterDepth: '8b78608c-69ec-4d42-8e69-400ea96b58ad',
  floodStandingWaterDuration: '744e2dd9-58c7-4cd4-b1f2-0b27e7e04781',
  floodStandingWaterRemoved: '12cd8cc5-b085-4bde-9e4e-efdfa32469eb',
  floodWaterSource: '12fa722c-ddbc-468f-83fd-ee5dcda83c6c',
  forename: 'e7679863-1d0a-467d-bbd7-9131383abd9b',
  fullName: '4cde1d83-eebe-4898-9eac-e19609c9e239',
  furtherDamage: 'fadc335c-5701-4c95-b3db-0fb6a1414483',
  hasMoistureSoddenMaterials: '6c164c17-3ba6-432d-a0ec-3acc20df5f8a',
  hasSpecifiedItems: '4e52f9b3-8fb5-4981-8dfa-70b193a8f1df',
  hasUnoccupiedExtendedPerils: 'f6a7b8c9-0d1e-4f2a-b3c4-d5e6f7a8b9c0',
  highestSectionStartedPosition: 'highestSectionStartedPosition',
  historyId: 'f2a47eef-e4ab-4e92-a675-1cce6b28c569',
  inceptionDate: 'da08c826-23e9-4eb2-adee-dea937f24c83',
  incidentDescription: '46e28371-26cb-4026-af6b-9a2f7f1b4118',
  incidentLocation: 'a3f81d6b-2c74-4e05-b917-5d28ac6f3e91',
  insuredAddress: 'd03e033a-f609-4024-a7c8-178a19e43624',
  isCountryUk: '03bd063c-eef4-4f27-a929-7a44ea6ebe4e',
  isCoverAlertTriggered: '7304ed89-a049-47d8-a211-3faf7a0d9bf1',
  isCurrentAddress: 'fc77b9cb-6131-4150-8682-ad1903cc0f17',
  isFloodRe: 'aaca7b67-8ece-4758-820a-4f5e3654191d',
  isForcedEntry: '40ee80df-6f15-48b4-b8cc-d14a4051bb65',
  isHabitable: '43a6a283-463a-4b4d-86fa-e9c82192bf7b',
  isInspectionConditionMet: '6a0a8498-80ce-49a9-b791-90449ee91558',
  isLeakRepaired: '4ec76510-6453-40b8-9db9-d7e703803741',
  isListedBuilding: '424b06e8-ee6c-4f50-a565-a62c548edc27',
  isListedFeatureDamaged: '0f362e24-d1f9-43f7-b3e4-d0f5a29574c2',
  isLossAssessorAppointed: '1d05ff85-161b-4ed7-9710-f2148c90de11',
  isNeighbouringPropertyDamaged: 'cd10a2e6-db82-4588-99c5-92119b5e2405',
  isPropertySecure: 'b5d29c73-6e41-4a80-95f2-7c163ba48d02',
  isRegisteredAddressForFiveYears: '2f9e3759-a64f-4948-aa60-f64e4103d0de',
  isRegisteredAddressForFiveYearsForJph: 'f637e907-4dfa-4583-8e07-31f6bdbe21ef',
  isReportedToPolice: '8d41c7b2-05e6-4a39-9f18-3b6ca7d21e50',
  isStandingWaterPresent: 'fc876946-b07f-433a-839b-f7f9ffb7abce',
  isUnoccupied: 'e5f6a7b8-9c0d-4e1f-a2b3-c4d5e6f7a8b9',
  isVulnerable: 'd63fcb11-57aa-41c0-ac5f-45db92ba793b',
  isWaterLeaking: '3b9b1f56-8f29-49ab-b017-a804d3774ad7',
  itemApproxValue: '6c7d8e9f-0a1b-42c3-d4e5-f6a7b8c9d0e1',
  itemCategory: '21324a5b-6c7d-4e9f-0a1b-2c3d4e5f6a7b',
  itemImei: '4a5b6c7d-8e9f-40a1-b2c3-d4e5f6a7b8c9',
  itemMakeModel: '324a5b6c-7d8e-4f0a-1b2c-3d4e5f6a7b8c',
  itemsDamaged: 'c13dd26f-c456-44a6-8ebc-4e226978e3a4',
  itemWorth: '2c8ee586-4ec6-4149-98c1-ad9a299c869b',
  journeyPhase: 'fbc4853e-6cab-4010-9033-1a1c12952042',
  jphDetails: '5b599a50-e833-4fd1-bdd8-e9bf166720e5',
  jphDob: 'b5e04d3c-c5b4-496b-aa94-3d98627fffb5',
  jphName: '669602fe-1439-49b0-8197-a03373fb8bd5',
  lastVisitToProperty: 'c9f7e2a1-4b3d-4e8f-9a0c-1d2e3f4a5b6c',
  leakCause: 'c4d5e6f7-a8b9-4c0d-e1f2-345678901abc',
  leakDetailsBack: '9afea60e-a709-4dd4-b705-8b5bc4ac76f3',
  leakDetailsContinue: '0af9f268-b43a-45bd-850d-6e4e852b2c74',
  leakDuration: '0120c29d-477c-4109-b7a6-5d14811519df',
  leakOriginFloor: 'cb8430b1-1737-48c3-a702-a7ddf9823ff1',
  leakOriginFloorOther: 'b494f02a-33ae-43b8-97a0-bc7c37ad7406',
  leakOriginLocation: '40ed96d5-8dcb-45c0-bd20-e16d423f3dab',
  leakRepairAction: '1e3631de-5c7f-406a-bd28-ad016e5b9473',
  leakRepairTiming: '31138652-3c68-46be-895f-1fe528d9b945',
  leakSource: 'df902a32-b775-42ce-8bf5-9015a3c14e56',
  leakSourceOther: 'e55e1b50-b5bb-4518-a22e-59bb5e18a2d4',
  lossDate: '84708915-0833-4022-ab26-76fda1fd2db0',
  metadata: '284e503d-289a-4f82-86bd-f9bf57e97d2d',
  movedInDate: 'd8ca9b21-b6cb-4fe4-b054-0f69ab872bec',
  movedOutDate: '11f6bf1e-2c55-4fd3-b196-a3c5ebec6815',
  otherReason: 'b1b2e92c-1e2f-464f-afd2-e7fad192ab84',
  pageCoverAlert: '4a631a99-3620-4a0c-9215-fa7b22060f12',
  perilInformation: 'c70ef292-da41-4639-b0f6-9774c770e8c6',
  perilType: 'dbf013fc-6b51-4a8d-8ae3-116c8c16a672',
  phoneNumber: 'f4d6c61f-c772-4041-8824-d96d9c869118',
  policyBooklet: '5283b2b5-8ceb-4ab0-acdf-aa93f76152d8',
  policyCoverType: 'b13df2d9-687f-4515-85f5-aa2eb1229663',
  policyData: '66b98f8f-6d5a-4c1f-b532-343dcf596f69',
  policyDetailsId: 'f96666bd-a5ce-4209-bf57-3d2b140eea28',
  policyholderFullName: 'fccd4621-dbcd-4825-a2e0-b1913a803ef2',
  policyInstance: 'bb1a0163-77ac-4108-be8e-dd3b602b5c4f',
  postcode: '2a9c97ad-838a-429d-ad36-ee92fe8954cd',
  previousClaimCauseCode: '76ac5f81-95e6-4c50-a1b6-eac2f489ed85',
  previousClaimCost: 'e6e4bc51-5d3f-424e-9735-cb113f6c49f9',
  previousClaimDate: 'eedfe895-81ca-4651-af5e-ee57c85ca987',
  previousClaimDetails: 'a66e2c4b-4916-4159-9373-4e927b3c886b',
  product: '60968b87-cb84-4e47-b10c-0a5e4e9912b2',
  propertyCustomerDetailsContinue: 'fa326f33-570c-44c5-82c1-05671f9e6be4',
  propertyNameNumber: 'ed919978-ffcd-42a7-b507-3f728e1f8929',
  propertyType: '7dc9314a-e2a8-4888-8de9-dd66bc42e356',
  questionSetId: 'questionSetId',
  readOnlySummary: 'bd970012-aea4-4418-a978-c283f915a69e',
  removeAddressButton: '1ae25bf9-a270-418f-acc3-ae2903a41080',
  removeRoomButton: 'a6b4dbcb-0f76-41f7-93db-f42598a6a7fa',
  riskAddress: '208286b6-89d0-4388-aab7-ab8bb52f3fd9',
  riskPostcode: 'e4fbfc31-29dd-4de4-8904-62f1633eaf24',
  roomsAffectedText: '5a925f64-82d1-44ec-b0be-e2a17f52a302',
  roomType: '60f01c6d-7b1c-4c75-bad5-a8fa20a239c7',
  roomTypeOther: '20556deb-8771-4f83-8bd7-e8e3136f598d',
  routingNumber: '72562131-d1de-48c6-ba9a-17ca661a3e3f',
  saveClaimModal: '450bbf93-b2a1-4082-b6ae-a186f48ca3b7',
  scoreTotal: 'e806a95a-d2ab-435a-be33-8b63b1c87e38',
  secondaryEmail: '78735e67-0f61-4602-8b24-0273cfa1781b',
  seedDamagedItem: '49ad0736-cae6-4d30-9662-89785eb2f9d5',
  seedDamagedRoom: '9f82c399-0f83-40f1-8e2d-fa37247c9b44',
  showParticularSection: '31714539-ccfe-4151-a7f7-3792adcf7288',
  siteViewMeetingId: '323a4b4c-ae9e-4b68-8e6c-71f248d617ee',
  sortCode: 'e9b1b9c0-5cbd-4f35-a05f-4e08dca2190a',
  specifiedItemCoverLevel: 'c83544f2-80d7-4b5b-943e-33fe6c5682f7',
  specifiedItems: '94739ccc-4e00-4df6-b820-5ccc5c87d432',
  specifiedItemsAlert: '8a79e6e4-7314-456e-ab2c-8488da2e7404',
  specifiedItemsCount: '14113686-3f6e-4e0d-b6d5-71c0ff3d35e7',
  specifiedItemsOther: 'f963eb8e-9a89-4bf9-b9eb-a903b5821f2c',
  startDate: 'b83269b6-dd79-4a98-8bf5-d7eb6aaea146',
  subFloorComposition: '81ce63d6-9662-449e-8d70-f94a9a8af969',
  submitClaimModal: 'a4f5d335-1be1-49f1-ac94-dd463e9fa785',
  submittedBy: 'b8e14b1d-5b62-42ae-bd40-ffad9f8b3fcc',
  subsidenceExcess: '66c0ba76-0100-4500-b847-f78d69448090',
  surname: '9c70fa32-97cf-42d0-9c8e-7c4aa1f4b3f3',
  theftAreaDamaged: 'c7a13e84-4f96-4b27-8d05-1e73fa28c690',
  theftAreaDamagedOther: 'd9c46b18-7a35-4e21-b806-5f92ad13c74e',
  theftElementsDamaged: 'd8b52a91-7c63-4e08-b41f-9a26ce50d374',
  theftEntryMethod: 'b4e92f07-3d85-4c16-a028-6e39bd704f12',
  theftHowItemsTaken: 'a2d95e41-0c36-4b59-8824-4f06bd731925',
  theftIncidentAddress: 'e6b74c25-8a19-4f37-9c60-2d84fb51a703',
  theftItemsTakenFrom: 'f1c86d30-9b25-4e48-a713-3e95ac620814',
  title: '0ffc639c-a5a2-44bf-a53c-f651ce7ad389',
  toAboutYourPolicy: '33836c36-caa0-4c6f-ac35-b2c1d5cd56fa',
  toAddressHistory: 'fd583edf-6b60-40bb-93be-1e2d27f9d51d',
  toBankDetails: '6e6770e3-6ee0-41e5-af29-667edbca0ae3',
  toBeforeYouContinue: 'cb50c575-2466-4c84-930c-019d22130e6b',
  toCoverOverview: '6553ceb7-d9ca-4bc2-9ef7-2966d89b9548',
  toCoverSummary: '2355a601-6a6f-4d9a-be8d-f9821e53a502',
  toCoverSummaryFromAlertPage: 'd2c15811-4b19-4487-a24b-759ce10b6919',
  toCustomerPortal: 'd95c57bb-cbdd-45e2-989a-3ba0c3d32f40',
  toIncidentDetails: 'a6a4055c-7ee0-47a1-9aaf-69829058a322',
  toLogAnIncident: 'd32f64a4-2448-449e-b442-aebc1db73e48',
  toPerilSelection: '9c2d1405-828f-40c1-86ef-999bf328ea2e',
  toSummary: 'f273fea1-b5c9-46c2-b8a8-6e217a712183',
  toTellUsAboutIncident: '0e51e627-f9e2-4249-84fc-9791a4ead7e0',
  toTellUsMoreAboutYourIncident: 'd317a856-67bc-4972-b0bd-002f65bb968f',
  toTellUsMoreAboutYourItem: '41285df2-35fa-4901-a3f8-c037a5f0ed43',
  toTellUsWhatHappened: '7efd5c3d-10e9-4637-82f1-8a1b09aa593e',
  townCity: 'be180206-55aa-403d-a0b3-5854c97665b0',
  toYourIncident: '33f3a12b-3005-42e3-b500-6844cba62f7c',
  unoccupiedBeforeLoss: 'cb7f9e00-b35f-4198-8047-83fd88a039b7',
  voluntaryExcessContents: 'e6a69d7e-a5b9-44fd-8cf4-41a5ba3eb505',
  vulnerabilitySupport: '95dab1b9-535a-4a9a-9591-edbda1fbb8fc',
  wasLeakVisibleImmediately: 'f59e6ff2-199f-46bf-aeba-94f110cf6428',
  wasTraceAndAccessRequired: '68353585-e88f-444c-9787-53181cff40fc',
  waterTravelExtent: 'bc270701-aab8-41e4-a5b5-18c2affd388d',
  wereOtherItemsDamaged: 'fcbb44d7-eb3b-4158-bb6b-84443cf8555b',
  whatHappened: '858faeed-4717-4596-bce4-705eefe3d9a2',
  whatWasDamaged: 'ed0e4633-8187-4ec7-8568-60561159e34d',
  whatWasDamagedAlert: '870133ed-152e-4203-8f4b-db033b591890',
  whatWasDamagedSomethingElse: '1920272d-3550-4626-a723-0fcf12bde543',
  whereWasDamaged: 'c19e0a4b-dd2b-4992-a517-c4c6835e5f44'
};

export interface HpQuestionIds {
  accidentalDamageLevelBuildings: string;
  accidentalDamageLevelContents: string;
  accountHolderName: string;
  accountHolderNameSomeoneElse: string;
  accountNumber: string;
  actionTaken: string;
  activeSectionId: string;
  adAddAnotherItemButton: string;
  adBoundaryAreaAffected: string;
  adBoundaryDamageExtent: string;
  adBoundaryExtentBack: string;
  adBoundaryExtentContinue: string;
  adBoundaryIsBespoke: string;
  adBoundaryIsRetainingWall: string;
  adBoundaryItemsDamaged: string;
  adBoundarySpecialistRequired: string;
  adBuildingsAreaDamaged: string;
  adBuildingsExtentBack: string;
  adBuildingsExtentContinue: string;
  adBuildingsIncidentBack: string;
  adBuildingsIncidentContinue: string;
  adBuildingSubmitClaim: string;
  adBuildingsWhatCaused: string;
  adBuildingsWhoCaused: string;
  adConservatoryAreaAffected: string;
  adConservatoryDamageExtent: string;
  adConservatoryExtentBack: string;
  adConservatoryExtentContinue: string;
  adConservatoryIsBespoke: string;
  adConservatoryItemsDamaged: string;
  adConservatorySpecialistRequired: string;
  adContentsIncidentBack: string;
  adContentsIncidentContinue: string;
  adContentsSubmitClaim: string;
  adContentsSubmitClaimBack: string;
  adContentsWhatHappened: string;
  adContentsWhereHappened: string;
  adContentsWhoCaused: string;
  adCoverLevel: string;
  addAnotherRoomButton: string;
  addonCode: string;
  addonDescription: string;
  addonDetails: string;
  addonWarning: string;
  addressCancelEdit: string;
  addressDataBeforeEdit: string;
  addressDetails: string;
  addressEdit: string;
  addressEnterManuallyButton: string;
  addressId: string;
  addressLine1: string;
  addressLine2: string;
  addressLookupButton: string;
  addressLookupJson: string;
  addressLookupResults: string;
  addressPolicyholderName: string;
  adDrivewayAreaAffected: string;
  adDrivewayDamageExtent: string;
  adDrivewayExtentBack: string;
  adDrivewayExtentContinue: string;
  adDrivewayIsBespoke: string;
  adDrivewayItemsDamaged: string;
  adDrivewaySpecialistRequired: string;
  adEssentialFacilitiesLost: string;
  adExternalWallAreaAffected: string;
  adExternalWallDamageExtent: string;
  adExternalWallExtentBack: string;
  adExternalWallExtentContinue: string;
  adExternalWallIsBespoke: string;
  adExternalWallItemsDamaged: string;
  adExternalWallSpecialistRequired: string;
  adIntroBack: string;
  adIntroContinue: string;
  adItemDamageExtent: string;
  adjustmentNeeded: string;
  adOutbuildingAreaAffected: string;
  adOutbuildingCeilingFinish: string;
  adOutbuildingDamageExtent: string;
  adOutbuildingExtentBack: string;
  adOutbuildingExtentContinue: string;
  adOutbuildingIsBespoke: string;
  adOutbuildingItemsDamaged: string;
  adOutbuildingSpecialistRequired: string;
  adOutbuildingSubFloorMaterial: string;
  adRemoveItemButton: string;
  adRoofAreaAffected: string;
  adRoofDamageExtent: string;
  adRoofExtentBack: string;
  adRoofExtentContinue: string;
  adRoofIsBespoke: string;
  adRoofItemsDamaged: string;
  adRoofSpecialistRequired: string;
  adUgsAreaAffected: string;
  adUgsExtentBack: string;
  adUgsExtentContinue: string;
  adUgsItemsDamaged: string;
  adWindowsAreaAffected: string;
  adWindowsDamageExtent: string;
  adWindowsExtentBack: string;
  adWindowsExtentContinue: string;
  adWindowsIsBespoke: string;
  adWindowsItemsDamaged: string;
  adWindowsSpecialistRequired: string;
  affectedSpecifiedItems: string;
  altPhoneNumber: string;
  areSpecifiedItemsAffected: string;
  areSpecifiedItemsAffectedValue: string;
  backToEnquiryDetails: string;
  buildingsSumInsured: string;
  ceilingFinish: string;
  checkYourCover: string;
  claimEnquiryReference: string;
  claimReference: string;
  claimStartedDate: string;
  claimSubmittedDate: string;
  compulsoryExcessBuildings: string;
  compulsoryExcessContents: string;
  contentsSumInsured: string;
  correspondenceAddress: string;
  country: string;
  county: string;
  coverName: string;
  coverSummaryAlert: string;
  coverType: string;
  crimeReferenceNumber: string;
  customData: string;
  customerDetails: string;
  damagedContentsItems: string;
  damagedContentsItemsOther: string;
  damagedElementAreaAffected: string;
  damagedElementIsBespoke: string;
  damagedElementSpecialistRequired: string;
  damagedItemDescription: string;
  damagedItemMakeModel: string;
  damagedItemOther: string;
  damageExtent: string;
  damageType: string;
  dateOfBirth: string;
  declaration: string;
  emailAddress: string;
  endDate: string;
  endorsementCode: string;
  endorsementDescription: string;
  endorsementDetails: string;
  endorsementHeader: string;
  eowExcessBuildings: string;
  eowExcessContents: string;
  essentialFacilitiesLost: string;
  excesses: string;
  extentOfDamageBack: string;
  extentOfDamageContinue: string;
  extentOfDamageSubmitClaim: string;
  floodAreaDamaged: string;
  floodElectricsAffected: string;
  floodStandingWaterDepth: string;
  floodStandingWaterDuration: string;
  floodStandingWaterRemoved: string;
  floodWaterSource: string;
  forename: string;
  fullName: string;
  furtherDamage: string;
  hasMoistureSoddenMaterials: string;
  hasSpecifiedItems: string;
  hasUnoccupiedExtendedPerils: string;
  highestSectionStartedPosition: string;
  historyId: string;
  inceptionDate: string;
  incidentDescription: string;
  incidentLocation: string;
  insuredAddress: string;
  isCountryUk: string;
  isCoverAlertTriggered: string;
  isCurrentAddress: string;
  isFloodRe: string;
  isForcedEntry: string;
  isHabitable: string;
  isInspectionConditionMet: string;
  isLeakRepaired: string;
  isListedBuilding: string;
  isListedFeatureDamaged: string;
  isLossAssessorAppointed: string;
  isNeighbouringPropertyDamaged: string;
  isPropertySecure: string;
  isRegisteredAddressForFiveYears: string;
  isRegisteredAddressForFiveYearsForJph: string;
  isReportedToPolice: string;
  isStandingWaterPresent: string;
  isUnoccupied: string;
  isVulnerable: string;
  isWaterLeaking: string;
  itemApproxValue: string;
  itemCategory: string;
  itemImei: string;
  itemMakeModel: string;
  itemsDamaged: string;
  itemWorth: string;
  journeyPhase: string;
  jphDetails: string;
  jphDob: string;
  jphName: string;
  lastVisitToProperty: string;
  leakCause: string;
  leakDetailsBack: string;
  leakDetailsContinue: string;
  leakDuration: string;
  leakOriginFloor: string;
  leakOriginFloorOther: string;
  leakOriginLocation: string;
  leakRepairAction: string;
  leakRepairTiming: string;
  leakSource: string;
  leakSourceOther: string;
  lossDate: string;
  metadata: string;
  movedInDate: string;
  movedOutDate: string;
  otherReason: string;
  pageCoverAlert: string;
  perilInformation: string;
  perilType: string;
  phoneNumber: string;
  policyBooklet: string;
  policyCoverType: string;
  policyData: string;
  policyDetailsId: string;
  policyholderFullName: string;
  policyInstance: string;
  postcode: string;
  previousClaimCauseCode: string;
  previousClaimCost: string;
  previousClaimDate: string;
  previousClaimDetails: string;
  product: string;
  propertyCustomerDetailsContinue: string;
  propertyNameNumber: string;
  propertyType: string;
  questionSetId: string;
  readOnlySummary: string;
  removeAddressButton: string;
  removeRoomButton: string;
  riskAddress: string;
  riskPostcode: string;
  roomsAffectedText: string;
  roomType: string;
  roomTypeOther: string;
  routingNumber: string;
  saveClaimModal: string;
  scoreTotal: string;
  secondaryEmail: string;
  seedDamagedItem: string;
  seedDamagedRoom: string;
  showParticularSection: string;
  siteViewMeetingId: string;
  sortCode: string;
  specifiedItemCoverLevel: string;
  specifiedItems: string;
  specifiedItemsAlert: string;
  specifiedItemsCount: string;
  specifiedItemsOther: string;
  startDate: string;
  subFloorComposition: string;
  submitClaimModal: string;
  submittedBy: string;
  subsidenceExcess: string;
  surname: string;
  theftAreaDamaged: string;
  theftAreaDamagedOther: string;
  theftElementsDamaged: string;
  theftEntryMethod: string;
  theftHowItemsTaken: string;
  theftIncidentAddress: string;
  theftItemsTakenFrom: string;
  title: string;
  toAboutYourPolicy: string;
  toAddressHistory: string;
  toBankDetails: string;
  toBeforeYouContinue: string;
  toCoverOverview: string;
  toCoverSummary: string;
  toCoverSummaryFromAlertPage: string;
  toCustomerPortal: string;
  toIncidentDetails: string;
  toLogAnIncident: string;
  toPerilSelection: string;
  toSummary: string;
  toTellUsAboutIncident: string;
  toTellUsMoreAboutYourIncident: string;
  toTellUsMoreAboutYourItem: string;
  toTellUsWhatHappened: string;
  townCity: string;
  toYourIncident: string;
  unoccupiedBeforeLoss: string;
  voluntaryExcessContents: string;
  vulnerabilitySupport: string;
  wasLeakVisibleImmediately: string;
  wasTraceAndAccessRequired: string;
  waterTravelExtent: string;
  wereOtherItemsDamaged: string;
  whatHappened: string;
  whatWasDamaged: string;
  whatWasDamagedAlert: string;
  whatWasDamagedSomethingElse: string;
  whereWasDamaged: string;
}

const sectionIdMap: HpSectionIds = {
  aboutYourIncident: '51c70e88-9598-4fbd-9b87-abe58a817d40',
  adBuildingsExtentBoundary: 'b01b31af-2d8b-4f95-ad29-8adbd5d2ba77',
  adBuildingsExtentConservatory: '0c4e8a17-6d92-4b53-8f71-2a5c9e3b1d68',
  adBuildingsExtentDriveway: '9613caad-dd61-4e0f-9412-322e8abc3874',
  adBuildingsExtentExternalWall: 'c555fb03-be91-4c34-bb50-9cb6ac557baa',
  adBuildingsExtentOutbuilding: '537b7b18-3e7b-4fca-b813-ddbaf9570c9b',
  adBuildingsExtentRoof: 'df6aa28f-91e2-469a-a1d5-319b8d1b5509',
  adBuildingsExtentUgs: '8857932f-3b6b-4894-bd4b-fd224ee4749e',
  adBuildingsExtentWindows: 'c301ff09-221b-4ebd-8761-de2933b9d5bf',
  addressHistory: '036cdecd-40c6-46cf-8bf8-f3f8f7b91771',
  bankDetails: '7d4efa33-2d65-446f-9243-f43228814818',
  buildingsExtentSummary: '24ebe699-5b03-4837-8bfb-38b4f812e740',
  buildingsIncidentDetails: '3d1bde7c-e251-4907-8220-6a45fd8b9e64',
  contentsIncidentDetails: '9add0e4b-d8ab-49a0-a7f0-ecdaaabc66cc',
  contentsItemDetails: 'e9049613-e5cd-47e7-863d-d77043415b73',
  coverAlert: '988691cf-0573-4d74-87ff-87658e6840af',
  coverOverview: '04a22563-56d7-474d-8ce3-5294f22568f2',
  damagedItem: 'ad2a1487-14b0-4b43-8ad7-1f8fca67dd08',
  damagedRoom: 'e9fa3e3e-27b5-444d-9d9d-8f30ef1db5e3',
  declaration: '02054e07-9438-4d19-8a84-47126f6f5831',
  extentOfDamage: 'bbe3471c-f6ec-4ce9-9ef4-2c698a9284a8',
  incidentIntro: '8b2ff6a4-cf08-4b41-a367-9a3859dbdb6d',
  incidentSummary: 'c8f0d48f-3b72-4427-8cff-887f89a84a0b',
  leakDetails: '888984d4-7aa2-4505-b108-9579d8083e82',
  makingAClaim: 'f139f506-c0ec-47bd-a019-de942b91439f',
  moreAboutTheIncident: '3b3bb369-5727-4648-b84f-9d7287659b3d',
  moreAboutTheItem: 'e419d2c8-e55b-4cbd-a11a-983b9d0272bc',
  propertyCustomerDetails: '4b19e0f7-23ce-4ed3-ab65-8b4cff1baadd',
  readOnlySummary: '71ee53a7-93f3-46a1-a9c5-bca72261704c',
  whatCausedTheIncident: 'ed4df441-43c8-4783-ab03-1a69b201ad58',
  whatHappened: 'a33fe37b-02f7-4cf7-8fcb-2815ac9a91e9'
};

export interface HpSectionIds {
  aboutYourIncident: string;
  adBuildingsExtentBoundary: string;
  adBuildingsExtentConservatory: string;
  adBuildingsExtentDriveway: string;
  adBuildingsExtentExternalWall: string;
  adBuildingsExtentOutbuilding: string;
  adBuildingsExtentRoof: string;
  adBuildingsExtentUgs: string;
  adBuildingsExtentWindows: string;
  addressHistory: string;
  bankDetails: string;
  buildingsExtentSummary: string;
  buildingsIncidentDetails: string;
  contentsIncidentDetails: string;
  contentsItemDetails: string;
  coverAlert: string;
  coverOverview: string;
  damagedItem: string;
  damagedRoom: string;
  declaration: string;
  extentOfDamage: string;
  incidentIntro: string;
  incidentSummary: string;
  leakDetails: string;
  makingAClaim: string;
  moreAboutTheIncident: string;
  moreAboutTheItem: string;
  propertyCustomerDetails: string;
  readOnlySummary: string;
  whatCausedTheIncident: string;
  whatHappened: string;
}

const productId = '35d65b5d-e0ac-4f68-8251-10d77658e397';
const questionIds = Object.freeze(questionIdMap) as Record<string, string>;
const sectionIds = Object.freeze(sectionIdMap) as Record<string, string>;

export { productId, questionIds, sectionIds };
